import React from 'react';
import { Flex, IconButton, Text, Box, Img } from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { appLogo } from '../../assets';

interface MobileHeaderProps {
    onOpenDrawer: () => void;
    onCloseDrawer: () => void;
    isDrawerOpen: boolean;
    drawerBtnRef: React.RefObject<HTMLButtonElement>;
    pageTitle?: string;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ 
    onOpenDrawer, 
    onCloseDrawer, 
    isDrawerOpen, 
    drawerBtnRef, 
    pageTitle 
}) => {
    const handleToggleDrawer = () => {
        if (isDrawerOpen) {
            onCloseDrawer();
        } else {
            onOpenDrawer();
        }
    };

    return (
        <Flex
            as="header"
            align="center"
            justify="space-between"
            p={3}
            bg="white"
            borderBottomWidth="1px"
            borderColor="gray.200"
            position="fixed"
            top={0}
            left={0}
            right={0}
            zIndex="sticky"
            h="60px"
        >
            <Flex align="center">
                <IconButton
                    ref={drawerBtnRef}
                    icon={isDrawerOpen ? <CloseIcon fontSize="xl" /> : <HamburgerIcon fontSize="2xl" />}
                    aria-label={isDrawerOpen ? "Close Menu" : "Open Menu"}
                    onClick={handleToggleDrawer}
                    variant="ghost"
                    size="lg"
                    mr={2}
                />
                <Img src={appLogo} alt='logo' maxH="30px" />
            </Flex>

            <Box flex={1} textAlign="center" px={2}>
                {pageTitle && (
                    <Text fontSize="lg" fontWeight="bold" color="gray.700" noOfLines={1} display="inline-block">
                        {pageTitle}
                    </Text>
                )}
            </Box>
            
            <Flex align="center" visibility="hidden">
                <IconButton
                    icon={<HamburgerIcon fontSize="2xl" />}
                    aria-label="Spacer"
                    variant="ghost"
                    size="lg"
                    mr={2}
                    disabled
                />
                <Img src={appLogo} alt='logo-spacer' maxH="30px" />
            </Flex>
        </Flex>
    );
};

export default MobileHeader;